// @ts-strict

import {
  AfterViewChecked,
  Component,
  ElementRef,
  forwardRef,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { LMDrillAroundStateService } from "@components/drillaround/lm-drill-around-state.service";
import { LMDrillAroundService, LMDrillNavigationComponent, LMDrillPointViewComponent } from '@app/components';
import { RouterStateSnapshot } from "@angular/router";
import { LMBusyIndicatorService, LMDrillService, LMUrlUtilService } from "@app/services";
import { DrillResource } from "@app/resources";
import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';

import 'ids-enterprise-wc/components/ids-splitter/ids-splitter';
import IdsSplitter, { IdsSplitterCollapseExpandOpts } from 'ids-enterprise-wc/components/ids-splitter/ids-splitter';
import 'ids-enterprise-wc/components/ids-splitter/ids-splitter-pane';
import { LMDrillAroundNode, LMDrillNavigationEvent } from '@components/drillaround/lm-drill-around-wc';
import 'ids-enterprise-wc/components/ids-breadcrumb/ids-breadcrumb';
import IdsBreadcrumb from 'ids-enterprise-wc/components/ids-breadcrumb/ids-breadcrumb';
import 'ids-enterprise-wc/components/ids-hyperlink/ids-hyperlink';
import 'ids-enterprise-wc/components/ids-button/ids-button';
import { Observable, Subscription } from 'rxjs';
import 'ids-enterprise-wc/components/ids-layout-grid/ids-layout-grid';
import 'ids-enterprise-wc/components/ids-layout-grid/ids-layout-grid-cell';

@Component({
  selector:    'lm-drill-around',
  templateUrl: './lm-drill-around.component.html',
  styleUrls:   [ './lm-drill-around.component.scss' ],
  providers: [ LMDrillAroundStateService ],
})
export class LMDrillAroundComponent  implements OnInit, AfterViewChecked, OnDestroy {
  @ViewChild('DRILL_AROUND_VIEW') drillAroundView!: LMDrillPointViewComponent;
  @ViewChild('DRILL_AROUND_VIEW_CONTAINER', { read: ViewContainerRef }) drillAroundViewContainer!: ViewContainerRef;

  // using forwardRef to get karma test to build!!!
  @ViewChild(forwardRef(() => LMDrillNavigationComponent)) private drillTree!: LMDrillNavigationComponent

  @ViewChild('IdsBreadcrumb', { read: ElementRef }) idsBreadcrumbElementRef: ElementRef | undefined;
  @ViewChild('IdsSplitter', { read: ElementRef }) idsSplitterElementRef: ElementRef | undefined;

  @Input() rootDataView!: LMDataView;
  @Input() rootDrillActions!: Array<LMDrillAction>;

  // experimentalComponentReuse = false;
  drillAroundViewInfo!: LMDrillAroundViewInfo;
  selectedDrillAroundNode: LMDrillAroundNode | undefined;
  showingNavigation = true;
  breadCrumbList: Array<SohoBreadcrumbItemOptions> | undefined;
  // splitterPosition = '30%';

  private idsBreadcrumb!: IdsBreadcrumb;
  private idsSplitter!: IdsSplitter;

  private breakpointObservable!: Observable<BreakpointState>;
  private breakpointObserverSubscription!: Subscription;

  // private readonly idsSplitterCollapseExpandOpts: IdsSplitterCollapseExpandOpts = {
  //   startPane: '#lm-drill-splitter-left',
  //   endPane: '#lm-drill-splitter-right',
  // };

  // private map = new Map<string, ViewRef>();
  // private drillViewCompRef!: ComponentRef<LMDrillPointViewComponent>;
  public collapsed?: boolean;

  constructor(
    private ngZone: NgZone,
    private breakpointObserver: BreakpointObserver,
    private lmBusyIndicatorService: LMBusyIndicatorService,
    private lmDrillAroundService: LMDrillAroundService,
    private lmUrlUtilService: LMUrlUtilService,
    private lmDrillService: LMDrillService,
    private lmDrillAroundStateService: LMDrillAroundStateService,
  ) {
  }

  ngOnInit(): void {
    const drillAroundResource = this.lmUrlUtilService.getRouteResource();
    const resourceId = drillAroundResource.resourceId;
    const drillResource = new DrillResource({ resourceId: resourceId, drillName: '_drillpoints_' });
    const drillUrl = this.lmUrlUtilService.buildUrl({ resource: drillResource });

    this.lmDrillService.getDrillAroundPoints(drillUrl).subscribe((response: LMDrillResponse) => {
      if (response.dataView && response.drillPoints) {
        this.rootDataView = response.dataView;
        this.rootDrillActions = response.drillPoints;
      }
    });
  }

  ngAfterViewChecked(): void {
    // -------------------------------------------------------------------------------
    // need to do this in ngAfterViewChecked since we have a ngIf in ng-container.
    // This means at the time of AfterViewInit we might not have the element in the
    // markup for the idsBreadcrumb and idsSplitter
    // -------------------------------------------------------------------------------

    if (!this.idsBreadcrumb && this.idsBreadcrumbElementRef) {
      this.idsBreadcrumb = this.idsBreadcrumbElementRef.nativeElement;
      this.setupBreadcrumbEvents();
    }

    if (!this.idsSplitter && this.idsSplitterElementRef) {
      this.idsSplitter = this.idsSplitterElementRef.nativeElement;
      this.setupSplitterEvents();
    }
  }

  ngOnDestroy(): void {
    if (this.breakpointObserverSubscription) {
      this.breakpointObserverSubscription.unsubscribe();
    }

    // event: size changed
    // (this.idsSplitter as any).removeEventListener('sizechanged', this.splitterSizeChanged);
  }

  private setupBreadcrumbEvents(): void {
    this.idsBreadcrumb.onBreadcrumbActivate = (targetEl: HTMLElement, previousEl: HTMLElement) => {
      const id = targetEl.getAttribute('target-id');
      if (!id) {
        console.log('cannot find target-id for selected breadcrumb item');
        return;
      }
      this.drillTree.selectNode(id);
    };
  }

  private setupSplitterEvents(): void {
    // setTimeout(() => {

    this.breakpointObservable = this.breakpointObserver.observe([ Breakpoints.XSmall ]);
    this.breakpointObserverSubscription = this.breakpointObservable.subscribe((result: BreakpointState) => {
      setTimeout(() => this.collapsed = result.matches);
        // console.log('result.matches = ' + result.matches, [result]);
        // if (result.matches) {
        //   this.ngZone.runOutsideAngular(() => {
        //     this.collapseSplitter();
        //   });
        // } else {
        //   this.ngZone.runOutsideAngular(() => {
        //     this.expandSplitter();
        //   });
        // }
    });
    // }, 1000);

    // if (this.breakpointObserver.isMatched(Breakpoints.XSmall)) {
    //   this.collapseSplitter();
    // }

    // // event: collapsed
    // (this.idsSplitter as any).addEventListener('collapsed', (e: CustomEvent) => {
    //   console.log('collapsed', e.detail);
    // });
    //
    // // event: expanded
    // (this.idsSplitter as any).addEventListener('expanded', (e: CustomEvent) => {
    //   console.log('expanded', e.detail);
    // });

    // event: size changed
    // (this.idsSplitter as any).addEventListener('sizechanged', this.splitterSizeChanged);
  }

  // private splitterSizeChanged = (e: Event) => {
  //   const event = (e as CustomEvent);
  //   // this.showingNavigation = event.detail.sizes[ 0 ] !== 0;
  //   console.log('sizechanged', [ this.showingNavigation, event.detail ]);
  // };

  public allowPageNavigation(nextState?: RouterStateSnapshot): Promise<boolean> | boolean {
    this.lmBusyIndicatorService.hideBusyIndicator();
    return this.lmDrillAroundService.runDrillAroundGuard(nextState);
  }

  onNavigationNodeSelected(event: LMDrillNavigationEvent): void {
    const drillAroundNode = event.data;
    this.selectedDrillAroundNode = drillAroundNode;
    this.lmDrillAroundStateService.fireSaveDrillStateEvent();
    this.runDrillAroundPoint(drillAroundNode);

    // if (this.experimentalComponentReuse) {
    //   this.runDrillAroundPointWithReuse(drillAroundNode);
    // } else {
    // this.runDrillAroundPoint(drillAroundNode);
    // }

    this.updateBreadCrumbs(drillAroundNode);
  }

  onDrillAroundEvent(event: LMDrillAroundEvent) {
    this.drillTree.addDrillChain(event.chain);
  }

  onToggleNavigation(event: any) {
    this.showingNavigation = !this.showingNavigation;
    this.collapsed = !this.showingNavigation;

    // this.showingNavigation = !this.showingNavigation;
    // if (this.showingNavigation) {
    //   this.idsSplitter.expand(this.idsSplitterCollapseExpandOpts);
    // } else {
    //   this.idsSplitter.collapse(this.idsSplitterCollapseExpandOpts);
    // }
  }

  // private collapseSplitter(): void {
  //   if (!this.idsSplitter) {
  //     return;
  //   }
  //   this.idsSplitter.collapse(this.idsSplitterCollapseExpandOpts);
  // }
  //
  // private expandSplitter(): void {
  //   if (!this.idsSplitter) {
  //     return;
  //   }
  //   this.idsSplitter.expand(this.idsSplitterCollapseExpandOpts);
  // }

  onViewDrillPointSelected(node: LMDrillAroundNode) {
    this.drillTree.selectedNode = node;
  }

  updateBreadCrumbs(node: LMDrillAroundNode) {
    setTimeout(() => {
      this.breadCrumbList = this.lmDrillAroundService.buildBreadCrumbs(this.rootDataView.representativeText, this.LMDrillBreadCrumbCallback, node);
    });
  }

  private runDrillAroundPoint(drillAroundNode: LMDrillAroundNode) {
    this.lmDrillAroundService.buildDrillAroundViewInfo(drillAroundNode).subscribe((response: LMDrillAroundViewInfo) => {
      this.drillAroundViewInfo = response;
    });
  }

  // private runDrillAroundPointWithReuse(drillAroundNode: LMDrillAroundNode) {
  //   const drillViewKey = drillAroundNode.id;
  //   if (this.map.has(drillViewKey)) {
  //     this.attachDrillViewComponent(drillAroundNode, this.map.get(drillViewKey));
  //   } else {
  //     this.lmDrillAroundService.buildDrillAroundViewInfo(drillAroundNode).subscribe(info => {
  //       this.buildViewComponent(info);
  //     });
  //   }
  // }

  // private detachDrillViewContainer() {
  //   if (this.drillViewCompRef) {
  //     const index = this.drillAroundViewContainer.indexOf(this.drillViewCompRef.hostView);
  //     if (index > -1) {
  //       this.drillAroundViewContainer.detach(index);
  //     } else {
  //       console.log('drillViewRef not in drillViewContainer');
  //     }
  //   }
  // }

  // private attachDrillViewComponent(drillAroundNode: LMDrillAroundNode, viewRef: ViewRef) {
  //   console.log('attachDrillViewComponent');
  //
  //   if (viewRef === undefined || viewRef.destroyed) {
  //     console.log('drillViewRef destroyed');
  //     this.map.delete(drillAroundNode.id);
  //     this.runDrillAroundPoint(drillAroundNode);
  //   } else {
  //     this.detachDrillViewContainer();
  //     console.log('attach clear:' + drillAroundNode.id);
  //     this.drillAroundViewContainer.clear();
  //     this.drillAroundViewContainer.insert(viewRef);
  //   }
  // }

  // private buildViewComponent(drillAroundViewInfo: LMDrillAroundViewInfo) {
  //   console.log('buildViewComponent');
  //
  //   this.detachDrillViewContainer();
  //   console.log('build clear:' + drillAroundViewInfo.key);
  //   this.drillAroundViewContainer.clear();
  //
  //   this.drillViewCompRef = this.drillAroundViewContainer.createComponent(LMDrillPointViewComponent);
  //   this.drillAroundView = this.drillViewCompRef.instance;
  //   this.drillAroundView.info = drillAroundViewInfo;
  //   this.map.set(drillAroundViewInfo.key, this.drillViewCompRef.hostView);
  //
  //   this.drillViewCompRef.onDestroy(() =>{
  //     console.log('onDestroy');
  //   });
  // }

  LMDrillBreadCrumbCallback = (e: SohoBreadcrumbEvent, args: any[]): boolean => {
    const id = e?.currentTarget?.id;

    if (id) {
      this.ngZone.run(() => this.drillTree.idsTree.select('#' + id));
    }
    return true;
  }
}
